// src/components/ContentFilters.jsx
import React from 'react';
import { X } from 'lucide-react';
import Logo from './Logo';

const ContentFilters = ({ 
  isOpen, 
  onClose, 
  activeFilters, 
  setActiveFilters, 
  contentTypeFilters,
  isDarkMode
}) => {
  const handleContentTypeToggle = (type) => {
    setActiveFilters(prev => {
      const isAllActive = prev.contentType.length === contentTypeFilters.length;
      
      if (isAllActive) {
        return {
          ...prev,
          contentType: [type]
        };
      }
      
      return {
        ...prev,
        contentType: prev.contentType.includes(type)
          ? prev.contentType.filter(t => t !== type)
          : [...prev.contentType, type]
      };
    });
  };

  return (
    <div 
      className={`
        fixed inset-y-0 left-0 z-20 w-72 flex flex-col transform transition-transform duration-300 ease-in-out
        ${isOpen ? 'translate-x-0' : '-translate-x-full'}
        ${isDarkMode ? 'bg-[#282828]' : 'bg-white'}
        md:sticky md:top-0 md:translate-x-0 md:h-screen
      `}
    >
      <Logo isDarkMode={isDarkMode} />
      
      <div className="flex-1 overflow-y-auto">
        <div className="p-6">
          <div className="flex justify-end md:hidden">
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-200"
            >
              <X size={24} />
            </button>
          </div>

          <div className="space-y-4">
            {contentTypeFilters.map(({ type, Icon }) => (
              <button
                key={type}
                onClick={() => handleContentTypeToggle(type)}
                className={`
                  w-full p-4 rounded-lg text-left transition-all flex items-center gap-3
                  relative overflow-hidden
                  ${isDarkMode 
                    ? 'bg-[#383838] text-gray-300 hover:bg-[#484848]'
                    : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                  }
                  ${activeFilters.contentType.includes(type) &&
                    'before:content-[""] before:absolute before:left-0 before:top-0 before:bottom-0 before:w-1 before:bg-[#e8c2d9]'
                  }
                `}
              >
                <Icon size={24} />
                <span className="text-lg">{type}</span>
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContentFilters;